import { TestId } from "@/constants/globals"
import { TagConfig } from "@/pages/Settings/Users/types"
import { ColorVariant } from "@/types/index"
import { UserRole, UserStatus } from "@/types/user"
import { capitalize } from "@/utils/lodash"

export const USER_ROLES = [
   UserRole.GUARD,
   UserRole.MANAGEMENT,
   UserRole.ADMIN,
].map((role) => ({
   value: role,
   label: capitalize(role),
   ["data-testid"]: TestId.USER_FORM_ROLES_DROPDOWN_OPTION,
}))

const ACTIVE_TAG: TagConfig = {
   label: "Active",
   variant: ColorVariant.HONOLULU_BLUE_DARK,
}

export const USER_STATUS_TAGS: Record<UserStatus, TagConfig> = {
   [UserStatus.ACTIVE]: ACTIVE_TAG,
   [UserStatus.ACTIVE_MFA_BYPASSED]: ACTIVE_TAG,
   [UserStatus.PENDING]: { label: "Pending", variant: ColorVariant.ORANGE },
   [UserStatus.INACTIVE]: { label: "Inactive", variant: ColorVariant.GRAY },
   [UserStatus.EXPIRED]: { label: "Expired", variant: ColorVariant.CERISE },
}

export const VALIDATION_PATTERNS = {
   NAME: /^.*$/,
   EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
   PHONE: /^[0-9\s-]+$/,
}

export const ERROR_MESSAGES = {
   NAME: "Field cannot be empty",
   EMAIL: "Invalid email format",
   PHONE: "Phone must contain 9-15 characters",
}
